// lib
import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

import ControlsComponents from '@aytm/app/stats/page/question-views/oe/components/ControlsComponents'
import OptionLabel from '@aytm/app/stats/page/question-views/components/controls/OptionLabel'

// styles
import style from '@aytm/app/stats/page/question-views/cn/components/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const Controls = ({ model, data, disabled, onConfigChange, ...props }) => {
  const { config, items } = model

  const answerOptions = [
    { key: '*', text: 'Entire conversation overview' },
    ...(items || []).map(item => ({ key: item.id, text: item.text, index: `A${item.position}` }))
  ]

  const answerItemTemplate = option =>
    option.hidden ? null : (
      <>
        <b>{option.index ? option.index + ': ' : ''}</b>
        <OptionLabel name="cn-answer" value={option.key} html={option.text} />
      </>
    )
  const answerValueTemplate = (option, _props) =>
    option ? (
      <>
        <b>{option.index ? option.index + ': ' : ''}</b>
        <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
      </>
    ) : (
      <span dangerouslySetInnerHTML={{ __html: _props.placeholder || 'Select...' }}></span>
    )

  const onChange = event => onConfigChange('ids', '*' == event.value ? null : event.value)

  return disabled ? null : (
    <div className={`${style.component} ${NO_PRINT}`}>
      <div data-testid="stat-cn-answer-filter" className={`${style.filter} p-fluid p-col`}>
        <Dropdown
          className="p-dropdown-rounded"
          aria-label="Answer"
          ariaLabel="Answer"
          value={config.ids ? config.ids : '*'}
          options={answerOptions}
          optionValue="key"
          optionLabel="text"
          optionDisabled="disabled"
          fixedDropdownDir="bottom"
          disabled={data.controls.config.filter?.disabled}
          itemTemplate={answerItemTemplate}
          valueTemplate={answerValueTemplate}
          onChange={data.controls.config.filter?.disabled ? null : onChange}
        />
      </div>
      <div className={`${style.controls} p-col`}>
        <ControlsComponents model={model} data={data} onConfigChange={onConfigChange} {...props} />
      </div>
    </div>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  disabled: PropTypes.bool,
  onConfigChange: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
